var _filter, _g, _circle, _g2, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 350 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 144,
    width: 206,
    x: 62,
    y: 117
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 4,
    result: "effect1_dropShadow_27_4637"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_27_4637"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 4,
    result: "effect2_dropShadow_27_4637"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_27_4637",
    mode: "normal",
    result: "effect2_dropShadow_27_4637"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_27_4637",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#edf0f7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 130,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 217,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 123,
    r: 6
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 175,
    fill: "#f6f7fb",
    r: 80
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#edf0f7",
    height: 104,
    rx: 6,
    width: 166,
    x: 82,
    y: 117
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.0703 143.186c0-1.105.8954-2 2-2h25.0237c1.104 0 2 .895 2 2v17.767c0 1.105-.896 2-2 2h-25.0237c-1.1046 0-2-.895-2-2z",
    fill: "#c7d0e5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.837,
    cy: 148.442,
    fill: "#9fa9c2",
    r: 12.093
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.325,
    cy: 148.442,
    fill: "#c7d0e5",
    r: 12.093
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#d4dbec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.0703 205.279c0-1.336 1.0829-2.419 2.4186-2.419h24.1861c1.336 0 2.419 1.083 2.419 2.419s-1.083 2.419-2.419 2.419h-24.1861c-1.3357 0-2.4186-1.083-2.4186-2.419z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.349 205.279c0-1.336 1.083-2.419 2.419-2.419h24.186c1.336 0 2.419 1.083 2.419 2.419s-1.083 2.419-2.419 2.419h-24.186c-1.336 0-2.419-1.083-2.419-2.419z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.628 205.279c0-1.336 1.083-2.419 2.419-2.419h24.186c1.336 0 2.419 1.083 2.419 2.419s-1.083 2.419-2.419 2.419h-24.186c-1.336 0-2.419-1.083-2.419-2.419z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.908 205.279c0-1.336 1.082-2.419 2.418-2.419h24.186c1.336 0 2.419 1.083 2.419 2.419s-1.083 2.419-2.419 2.419h-24.186c-1.336 0-2.418-1.083-2.418-2.419z"
  })))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 99,
    fill: "#edf0f7",
    r: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.163a1e55a8b517845b13cac03a38daff.svg";
export { ForwardRef as ReactComponent };